/* eslint-disable listeners/no-inline-function-event-listener */

const apiUtils = require('../common/utils/api');
const scrollUtils = require('../common/utils/scrollUtils');
const { getPositionRelativeToViewport } = require('../common/utils/viewport');
const { loadAssetsFromObject, forEachElement } = require('../common/utils/dom');
const { onDOMContentLoaded } = require('../common/utils/domEvents');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');

const analyticsEventCenter = getAnalyticsEventCenter();

const componentsForms = require('../components/forms');
const componentsClientSideValidation = require('../components/clientSideValidation');

const NAVIGATION_MENU_LINK = '.article-page .help-modal-menu a';
const ARTICLE_CONTENT_ASSET = '.article-page .content .content-asset';
const ARTICLE_CONTENT = '.article-page .content';
const BUTTON_SCROLL_TO_TOP = '.article-page .article__scroll-to-top[data-type=\'article-page\']';
const SUBMENU = '.article-page .article__nav';
const ELEMENT_TO_SCROLL = 'html, body';
const QUERY_STRING = 'aid';
const ACCORDION_QUESTION_QUERY_STRING = 'q';
const CONTACT_SELECTOR = '.article-page .help-modal-menu [data-link="contact"]';
const CONTACT_ID = 'contact';

const FRONT_CONFIG = getFrontConfig();

function scrollToId(element) {
  const $hook = $(`.article-page ${element}`);
  if ($hook.length !== 0) {
    scrollUtils.scrollToPosition(ELEMENT_TO_SCROLL, $hook);
  }
}

function handleClickInSubmenu() {
  forEachElement(
    document.querySelectorAll('.article-page .article__nav li'),
    (item) => {
      // eslint-disable-next-line listeners/no-missing-remove-event-listener
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const element = `#${item.dataset.id}`;
        scrollToId(element);
        window.location.hash = element;
      });
    },
  );
}

function updateBodyClass(articleId) {
  if (articleId === 'contact') {
    document.body.classList.add('body--contact');
    document.body.classList.remove('body--moreinfo');
  } else {
    document.body.classList.add('body--moreinfo');
    document.body.classList.remove('body--contact');
  }
}

function updatePath(element) {
  if (window.history.pushState) {
    const articleId = element.dataset.link;
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${QUERY_STRING}=${articleId}`;
    window.history.pushState({ path: newurl }, '', newurl);

    if (articleId === 'contact') { // need to force the init and validation form
      componentsForms.init();
      componentsClientSideValidation.init();
    }
  }
}

function updateTitle(title) {
  window.document.title = title;
}

function disableScrollListener() {
  window.removeEventListener('scroll', toggleButtonScrollToTop);
  scrollUtils.buttonScrollToTopVisible($(BUTTON_SCROLL_TO_TOP), false);
}

function handleScrollListeners() {
  if ($(SUBMENU).length !== 0) {
    handleClickInSubmenu();
    handleScrollInWindow();
  } else {
    disableScrollListener();
  }
}

function initArticleContent($articleContent, content, includeAssets = {}) {
  $articleContent.append(
    content,
  );

  loadAssetsFromObject(includeAssets);

  handleScrollListeners();
}

function setArticleContent(element) {
  // if the landing pages has no queryString there is no content asset
  if ($(ARTICLE_CONTENT_ASSET).length === 0) {
    $(ARTICLE_CONTENT).append(
      "<div class='content-asset'></div>",
    );
  }

  const $articleContentAsset = $(ARTICLE_CONTENT_ASSET);
  let $url = $(element) ? $(element).attr('href') : this.getAttribute('content-url');

  $articleContentAsset.empty();

  const $articleContent = $(ARTICLE_CONTENT);

  if ($articleContent !== null) {
    $articleContent.empty();
    const url = new URL($url);
    const urlParams = new URLSearchParams(url.search);
    urlParams.set('summary', true);

    const platformParameterName = FRONT_CONFIG.apiConfig.PLATFORM_PARAMETER_NAME;
    const platform = apiUtils.getParameterValueFromRequest(platformParameterName);
    if (!apiUtils.isWebPlatform(platform)) {
      urlParams.set(platformParameterName, platform);
    }

    if (element.dataset.link === CONTACT_ID) {
      $url = FRONT_CONFIG.urls?.contactUsForm;
    }

    $.get(`${$url.split('?')[0]}?${urlParams.toString()}`, (data) => {
      if (data.success) {
        initArticleContent($articleContent, data.content, data.includeAssets);
        updatePath(element);
        updateTitle(element.title);
        updateBodyClass(element.dataset.link);
        initScroll();
      }
    });
  }
}

function handleClickInMenu() {
  const helpMenuItem = document.querySelectorAll(NAVIGATION_MENU_LINK);

  Array.prototype.map.call(helpMenuItem, (element) => {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    element.addEventListener('click', (event) => {
      if (!element.classList.contains('selected')) {
        $('.article-page .help-modal-menu .selected').removeClass('selected');
        element.classList.add('selected');
        element.parentElement.classList.add('selected');

        if ((!element.classList.contains('external'))
          || (element.dataset.link && element.dataset.link === CONTACT_ID)) {
          event.preventDefault();
          $(window).scrollTop(0);
          setArticleContent(element);
        }

        disableScrollListener();
      } else {
        event.preventDefault();
      }
      // Send info for Analytics
      analyticsEventCenter.publish(
        analyticsEventCenter.EVENTS.faqsItemclicked, {
          item: element.dataset.link,
          option: analyticsEventCenter.EVENTS.PAYLOADS.faqsItemclicked.section,
        },
      );
    });
  });
}

function getQueries(queryId) {
  const url = new URL(window.location.href);
  return url.searchParams.get(queryId);
}

function handleHash() {
  $(() => {
    // if there is hash in the url then scroll to that position
    const { hash } = window.location;
    const $navigationSubmenu = $('.article-page .article__nav li');
    if (($navigationSubmenu.length !== 0) && hash) {
      $(window).scrollTop(0);
      scrollToId(hash);
    }
  });
}

function handleQueryString() {
  const query = getQueries(QUERY_STRING);
  if (query) {
    const helpMenuItem = document.querySelectorAll(NAVIGATION_MENU_LINK);
    Array.prototype.map.call(helpMenuItem, (element) => {
      const { link } = element.dataset;
      if (link === query) {
        element.classList.add('selected');
        element.parentElement.classList.add('selected');
        element.parentElement.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    });

    initScroll();
    handleHash();
  }

  const accordionQuestionSelected = getQueries(ACCORDION_QUESTION_QUERY_STRING);
  if (accordionQuestionSelected) {
    const questionSelected = document.querySelector(`[data-question-id="${accordionQuestionSelected}"]`);
    const contentSelected = questionSelected?.querySelector('.article-accordion__content.interaction--expand');
    contentSelected?.classList.add('interaction-active');
  }

  if (query === CONTACT_ID) {
    const element = document.querySelector(CONTACT_SELECTOR);
    setArticleContent(element);
  }
}

function toggleButtonScrollToTop() {
  const scrollToTopElement = document.querySelector(BUTTON_SCROLL_TO_TOP);
  if (scrollToTopElement) {
    const position = getPositionRelativeToViewport(document.querySelector(SUBMENU));
    scrollToTopElement.setAttribute('data-is-visible', position.isAbove);
  }
}

function handleScrollInWindow() {
  if ($('.article-page')) {
    window.addEventListener('scroll', toggleButtonScrollToTop);
  }
}

function onButtonToScrollTopClick(e) {
  scrollUtils.onClickButtonScrollToTop(e, ELEMENT_TO_SCROLL, $(SUBMENU));
}

function initScroll() {
  const buttonToScroll = document.querySelector(BUTTON_SCROLL_TO_TOP);
  if (buttonToScroll) {
    scrollUtils.buttonScrollToTopVisible($(BUTTON_SCROLL_TO_TOP), false);
    buttonToScroll.addEventListener('click', onButtonToScrollTopClick);
    handleScrollListeners();
  }
}

export function destroy() {
  const buttonToScroll = document.querySelector(BUTTON_SCROLL_TO_TOP);
  buttonToScroll.removeEventListener('click', onButtonToScrollTopClick);
}

export function init() {
  handleClickInMenu();
  handleQueryString();
}

export default {
  init,
  destroy,
};

onDOMContentLoaded(() => {
  init();
});
